<template>
  <main class="app">
    <router-view v-slot="{ Component }">
      <component :is="Component" />
    </router-view>
  </main>
</template>

<script>

export default {
}
</script>

<style lang="scss">
@import "@/assets/scss/app-scoped.scss";
</style>

<style lang="scss">
@import "@/assets/scss/app-global.scss";
</style>
